<template>
    <div>
        <!-- <label class="font-bold" :class="enable ? 'text-gray-500' : 'text-blue-500'" for="">{{title}}</label> -->
        <p class="font-bold" :class="enable ? 'text-black' : 'text-gray-400'">{{title}}</p>
        <!-- {{radioValue.length}} -->
        <button @click.prevent="showSelectStatus = !showSelectStatus" :disabled="!enable" :class="enable ? 'text-black border-gray-500 hover:bg-gray-300 focus:border-gray-300' : 'text-gray-400 bg-[#CDCDCD]'" class="transition-all form-select border rounded-2xl w-full text-left max-h-[42px] mt-1 overflow-hidden overflow-ellipsis whitespace-nowrap">
            {{placeholder}}
        </button>
        <div :class="showSelectStatus ? '' : 'hidden'" class="flex flex-col border border-gray-300 bg-white rounded-2xl mt-2 overflow-auto max-h-[50vh]">
            <label class="flex items-center gap-x-2 p-2" :class="option == options[0] ? '' : 'border-t-2'" v-for="(option, key) in options" :key="option.id || option.name || key">
                <input type="checkbox" :value="option" @click="setValue(option)" :ref="'checkbox-' + key">
                <p>{{option.name || option}}</p>
            </label>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            title: String,
            options: Object,
            enable: {
                type: Boolean,
                default: true
            },
            placeholder: String,
            onChange: Object,
            modelValue: Object,
        },
        data() {
            return {
                radioValue: '',
                showSelectStatus: false,
                selectList: []
            }
        },
        watch: {
            options: {
                handler(newValue, oldValue) {

                    if(this.selectList.length > 0) {
                        oldValue.forEach((el, index) => {
                            this.$refs['checkbox-' + index].checked = false
                        })
                    }

                    this.selectList = [];
                    this.$emit('updateValue', this.selectList);
                },
                immediate: true,
            },
            modelValue(newValue) {

                if(newValue != this.selectList) {
                    this.selectList = newValue;
                }
            }
        },
        methods: {
            setValue(value) {
                if(this.selectList.find(item => item.id === value.id)) {
                    this.selectList = this.selectList.filter(item => item.id !== value.id);
                } else {
                    this.selectList.push(value)
                }

                this.$emit('updateValue', this.selectList);
            }
        }
    }
</script>
